import { Buffer } from 'buffer'
import Amplify, { API, Storage } from 'aws-amplify'
import Papa from 'papaparse'
import PriceFileNotImportedError from 'views/SiteProducts/PriceFileNotImportedError'
import SaveOverridesError from 'views/SiteProducts/SaveOverridesError'

const util = require('util')
const zlib = require('react-zlib-js')
const gunzip = util.promisify(zlib.gunzip)

const amplifyConfig = {
  Auth: {

    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: process.env.REACT_APP_IDENTITYPOOLID,

    // REQUIRED - Amazon Cognito Region
    region: process.env.REACT_APP_REGION,

    // OPTIONAL - Amazon Cognito Federated Identity Pool Region
    // Required only if it's different from Amazon Cognito Region
    // identityPoolRegion: 'us-east-1',

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_USERPOOLID,

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.REACT_APP_USERPOOLWEBCLIENTID,

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: true

    // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    // authenticationFlowType: 'USER_PASSWORD_AUTH'
  },
  API: {
    endpoints: [
      {
        name: 'Portal API',
        endpoint: process.env.REACT_APP_PORTALAPI,
        region: process.env.REACT_APP_REGION
      },
      {
        name: 'Reporting API',
        endpoint: process.env.REACT_APP_REPORTINGAPI,
        region: process.env.REACT_APP_REGION
      },
      {
        name: 'Common API',
        endpoint: process.env.REACT_APP_COMMONAPI,
        region: process.env.REACT_APP_REGION
      }
    ]
  },
  Storage: {
    AWSS3: {
      bucket: 'rfat-portal-user-storage-' + process.env.REACT_APP_ENV,
      region: process.env.REACT_APP_REGION
    }
  }
}

if (window.location.hostname !== 'localhost') {
  // OPTIONAL - Configuration for cookie storage
  // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
  amplifyConfig.Auth.cookieStorage = {
  // REQUIRED - Cookie domain (only required if cookieStorage is provided)
    domain: process.env.REACT_APP_ENV === 'prod' ? '.shopmate.co.uk' : '.atlasproject.co.uk',
    // OPTIONAL - Cookie path
    path: '/',
    // OPTIONAL - Cookie expiration in days
    expires: 365,
    // OPTIONAL - Cookie secure flag
    // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
    secure: true
  }
}

Amplify.configure(amplifyConfig)

const dashboardResponse = async () => {
  // Rest Api call
  const apiName = 'Portal API'
  const path = '/org'
  const myInit = { // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {} // OPTIONAL
  }
  const res = await API.post(apiName, path, myInit)

  return (res.data)
}

const registerSitesResponse = async (data) => {
  // Rest Api call
  const apiName = 'Portal API'
  const path = '/link-org'
  const myInit = {
    headers: {},
    response: true,
    body: data
  }

  const res = await API.post(apiName, path, myInit)

  return (res.data)
}

const maskOrgResponse = async (data) => {
  // Rest Api call
  const apiName = 'Portal API'
  const path = '/mask-org'
  const myInit = {
    headers: {},
    response: true,
    body: data
  }

  const res = await API.post(apiName, path, myInit)

  return (res.data)
}

const siteSummary = async (data) => {
  // Rest Api call
  const apiName = 'Reporting API'
  const path = '/summary'
  const myInit = {
    headers: {},
    response: true,
    body: data
  }

  const res = await API.post(apiName, path, myInit)

  // if this contains hourly payments data it will be in UTC so convert to local timezone
  if ('sales' in res.data && 'today' in res.data.sales) {
    const correction = -(new Date().getTimezoneOffset() / 60)

    for (let i = 0; i < correction; i++) {
      res.data.sales.today.card.unshift(0)
      res.data.sales.today.card.pop()
      res.data.sales.today.cash.unshift(0)
      res.data.sales.today.cash.pop()
      res.data.sales.today.other.unshift(0)
      res.data.sales.today.other.pop()
    }

    for (let i = 0; i > correction; i--) {
      res.data.sales.today.card.push(0)
      res.data.sales.today.card.shift()
      res.data.sales.today.cash.push(0)
      res.data.sales.today.cash.shift()
      res.data.sales.today.other.push(0)
      res.data.sales.today.other.shift()
    }
  }

  return (res.data)
}

const getProducts = async (data) => {
  // Rest Api call
  const apiName = 'Reporting API'
  const path = '/products'
  const myInit = {
    headers: {},
    response: true,
    body: data
  }

  const res = await API.post(apiName, path, myInit)
  const gzData = Buffer.from(res.data, 'base64')
  const rawData = await gunzip(gzData)
  const jsonData = JSON.parse(rawData)

  // we'll take the responsibility here to determine the data structure
  // perhaps not the correct place but it keeps the business logic cleaner for now
  const payload = []
  for (let i = 0; i < jsonData.length; i++) {
    payload.push(
      {
        prodcode: jsonData[i][0],
        barcode: jsonData[i][1],
        description: jsonData[i][2],
        toplinecategory: jsonData[i][3],
        currentsaleprice: parseFloat(jsonData[i][4]),
        taxrate: parseFloat(jsonData[i][5]),
        issuenumber: parseInt(jsonData[i][6]),
        wholesaler: parseInt(jsonData[i][7]),
        packcost: parseFloat(jsonData[i][8]),
        packsize: parseInt(jsonData[i][9]),
        unitcostprice: parseFloat(jsonData[i][10]),
        datelastsold: new Date(jsonData[i][11]),
        qtyvaluesoldlastweek: jsonData[i][12],
        qtyvaluesoldlastmonth: jsonData[i][13],
        avqtysoldperweek: jsonData[i][14],
        promotion: jsonData[i][15],
        lastpricechangedate: jsonData[i][16],
        lastpricechangevalue: jsonData[i][17],
        daysatcurrentprice: jsonData[i][18],
        qtyinstock: parseInt(jsonData[i][19]),
        datestockadjusted: jsonData[i][20],
        lastadjustedreason: jsonData[i][21],
        lastgoodsin: jsonData[i][22]
      }
    )
  }

  return (payload)
}

const getCategories = async (siteId) => {
  // Rest Api call
  const apiName = 'Common API'
  const path = `/site/${siteId}/categories`
  const params = {
    headers: {},
    response: true
  }

  const res = await API.get(apiName, path, params)

  return (res.data)
}

const getSpecificCategories = async (siteId, categoryId) => {
  // Rest Api call
  const apiName = 'Common API'
  const path = `/site/${siteId}/categories/${categoryId}`
  const params = {
    headers: {},
    response: true
  }

  const res = await API.get(apiName, path, params)

  return (res.data)
}

const addCategory = async (siteId, name, parentId) => {
  const apiName = 'Common API'
  const path = `/site/${siteId}/categories`
  const params = {
    headers: {},
    response: true,
    body: {
      parentId: parentId,
      name: name
    }
  }

  const res = await API.post(apiName, path, params)

  return (res.data)
}

const deleteCategory = async (siteId, categoryId) => {
  const apiName = 'Common API'
  const path = `/site/${siteId}/categories/${categoryId}`
  const params = {
    headers: {},
    response: true
  }

  const res = await API.del(apiName, path, params)

  return (res.data)
}

const getSiteProductLookups = async (siteId) => {
  // Rest Api call
  const apiName = 'Common API'
  const path = `/site/${siteId}/product_lookups`
  const myInit = {
    headers: {},
    response: true
  }

  const response = await API.get(apiName, path, myInit)

  return (response.data)
}

const getSiteProducts = async (siteId) => {
  // Rest Api call
  const apiName = 'Common API'
  const path = `/site/${siteId}/products`
  const myInit = {
    headers: {},
    response: true
  }

  try {
    await API.get(apiName, path, myInit)
  } catch (err) {
    console.log(err.response)

    if (err.response.status === 404) {
      throw new PriceFileNotImportedError('No price file has yet been imported for this site')
    } else {
      throw new Error('Error calling product API')
    }
  }

  // nulls coming from the csv file are not clearly stored as a null so we need to convert them to a proper null value; I can't find a PapaParse function
  // to do it automatically so we use this simple function
  const processNulls = (value, field) => {
    if (value === '') {
      return null
    } else {
      return value
    }
  }

  let result = await Storage.get('product-cache/' + siteId, { level: 'private', download: true })

  let jsonData = Papa.parse(await result.Body.text(), {
    transform: processNulls
  })

  result = null // allow gc

  const products = []
  for (let i = 0; i < jsonData.data.length - 1; i++) {
    // uneditable fields don't have an original value supplied
    products.push(
      {
        product_id: {
          value: jsonData.data[i][0]
        },
        barcode: {
          value: jsonData.data[i][1]
        },
        product_num: {
          value: jsonData.data[i][2],
          original: jsonData.data[i][3]
        },
        product_description: {
          value: jsonData.data[i][4],
          original: jsonData.data[i][5]
        },
        product_short_description: {
          value: jsonData.data[i][6],
          original: jsonData.data[i][7]
        },
        item_size_desc: {
          value: jsonData.data[i][8],
          original: jsonData.data[i][9]
        },
        category_id: {
          value: jsonData.data[i][10],
          original: jsonData.data[i][11]
        },
        tax_id: {
          value: parseFloat(jsonData.data[i][12]),
          original: parseFloat(jsonData.data[i][13])
        },
        wholesaler_id: {
          value: parseInt(jsonData.data[i][14]),
          original: parseInt(jsonData.data[i][15])
        },
        pack_cost: {
          value: parseInt(jsonData.data[i][16]),
          original: parseInt(jsonData.data[i][17])
        },
        pack_size: {
          value: parseInt(jsonData.data[i][18]),
          original: parseInt(jsonData.data[i][19])
        },
        unit_rrp: {
          value: parseInt(jsonData.data[i][20]),
          original: parseInt(jsonData.data[i][21])
        },
        price_marked: {
          value: jsonData.data[i][22] === 't',
          original: jsonData.data[i][23] === 't'
        },
        markup_calculation_value: {
          value: jsonData.data[i][24] === null ? 0 : Number(jsonData.data[i][24])
        },
        markup_calculation_type: {
          // if an unpriced product, we set type as null so it doesn't render a value - we can then replace the empty string using CSS to display N/A
          value: jsonData.data[i][25] === null && jsonData.data[i][27] === 'priced' ? 'PriceOverRRP' : jsonData.data[i][25]
        },
        user_created: {
          value: jsonData.data[i][26] === 't'
        },
        type: {
          value: jsonData.data[i][27]
        },
        restricted_age_id: {
          value: parseInt(jsonData.data[i][28]),
          original: parseInt(jsonData.data[i][29])
        }
      }
    )
  }

  jsonData = null // allow gc

  return (products)
}

const saveProductOverrides = async (siteId, data) => {
  const batchSize = 5000
  let position = 0

  while (position < data.length) {
    const batchData = data.slice(position, position + batchSize)

    try {
      await saveProductOverrideChunk(siteId, batchData)

      position += batchSize
    } catch (err) {
      console.log('api gw error:', err)

      throw new SaveOverridesError(err, position) // we throw this so if we have an error thrown after some batches have been successful, we can still mark them as saved
    }
  }
}

const saveProductOverrideChunk = async (siteId, data) => {
  // Rest Api call
  const apiName = 'Common API'
  const path = `/site/${siteId}/products`
  const myInit = {
    headers: {},
    response: true,
    body: {
      overrides: data
    }
  }

  await API.put(apiName, path, myInit)
}

global.atlasResponseCache = {}

const reportResponse = async (startDate, endDate, comparisonDate, sites, aggregation, type, token) => {
  // check if we're waiting on another identical response
  if (type in global.atlasResponseCache && global.atlasResponseCache[type].token === token) {
    // already waiting on a response
    const res = await awaitCache(type)
    return (res.data)
  } else {
    global.atlasResponseCache[type] = { token: token, finished: false }
  }

  // call report data
  const apiName = 'Reporting API'
  const path = '/itemsales'
  const myInit = { // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: { startDate: startDate, endDate: endDate, comparisonDate: comparisonDate, sites: sites, aggregation: aggregation, data: type } // OPTIONAL
  }

  const res = await API.post(apiName, path, myInit)

  global.atlasResponseCache[type].response = res
  global.atlasResponseCache[type].finished = true

  return (res.data)
}

const awaitCache = async (type) => {
  while (global.atlasResponseCache[type].finished === false) {
    await new Promise((resolve, reject) => setTimeout(resolve, 50))
  }

  return global.atlasResponseCache[type].response
}

const getHotkeyLookups = async (siteId) => {
  // Rest Api call
  const apiName = 'Common API'
  const path = `/site/${siteId}/hotkey_lookups`
  const myInit = {
    headers: {},
    response: true
  }
  try {
    const response = await API.get(apiName, path, myInit)

    if (response.data.status === 200) {
      return (response.data.payload)
    } else {
      throw new Error('Failed to load Hotkey Lookups:', response)
    }
  } catch (err) {
    console.log(err.response)

    throw new Error('Unable to load Hotkey Lookups')
  }
}

const getHotkeyElements = async (siteId, parentId) => {
  const parentIdPath = parentId === null ? 'root' : parentId

  // Rest Api call
  const apiName = 'Common API'
  const path = `/site/${siteId}/hotkeys/${parentIdPath}`
  const myInit = {
    headers: {},
    response: true
  }

  try {
    const response = await API.get(apiName, path, myInit)

    if (response.data.status === 200) {
      return (response.data.payload)
    } else {
      throw new Error('Failed to load Hotkey Elements:', response)
    }
  } catch (err) {
    console.log(err.response)

    throw new Error('Unable to load Hotkey Elements')
  }
}

const saveHotkeyElements = async (siteId, parentId, updatedHotkeyElements, deletedElementIds) => {
  const parentIdPath = parentId === null ? 'root' : parentId

  // Rest Api call
  const apiName = 'Common API'
  const path = `/site/${siteId}/hotkeys/${parentIdPath}`
  const myInit = {
    headers: {},
    response: true,
    body: {
      hotkeyElements: updatedHotkeyElements,
      deletedHotkeyElementIds: deletedElementIds
    }
  }

  try {
    await API.put(apiName, path, myInit)
  } catch (err) {
    throw new Error('Failed to save hotkeys')
  }
}

const productSearch = async (siteId, searchValue, searchOperator, types, unbarcoded) => {
  // Rest Api call
  const apiName = 'Common API'
  const path = `/site/${siteId}/products/search`
  const myInit = {
    headers: {},
    response: true,
    body: {
      searchValue,
      searchOperator,
      types,
      unbarcoded
    }
  }

  try {
    const response = await API.post(apiName, path, myInit)

    if (response.data.status === 200) {
      return (response.data.payload)
    } else {
      throw new Error('Failed to search for hotkey products:', response)
    }
  } catch (err) {
    console.log(err)

    throw new Error('Unable to search for hotkey products')
  }
}

const publishHotkeys = async (siteId) => {
  // Rest Api call
  const apiName = 'Common API'
  const path = `/site/${siteId}/hotkeys/publish`
  const myInit = {
    headers: {},
    response: true,
    body: {}
  }

  try {
    const response = await API.post(apiName, path, myInit)

    if (response.data.status === 200) {
      return (response.data.payload)
    } else {
      throw new Error('Failed to publish hotkeys:', response)
    }
  } catch (err) {
    console.log(err)

    throw new Error('Unable to publish hotkeys')
  }
}

const getHotkeysPublishStatus = async (siteId) => {
  // Rest Api call
  const apiName = 'Common API'
  const path = `/site/${siteId}/hotkeys/publish`
  const myInit = {
    headers: {},
    response: true
  }

  try {
    const response = await API.get(apiName, path, myInit)

    if (response.data.status === 200) {
      return (response.data.payload)
    } else {
      throw new Error('Failed to get publish hotkeys status:', response)
    }
  } catch (err) {
    console.log(err)

    throw new Error('Unable to get publish hotkeys status')
  }
}

const getShelfEdgeLabels = async (siteId) => {
  // Rest Api call
  const apiName = 'Common API'
  const path = `/site/${siteId}/shelf_edge_labels`
  const myInit = { // OPTIONAL
    headers: {}, // OPTIONAL
    response: true // OPTIONAL (return the entire Axios response object instead of only response.data)
  }
  const res = await API.get(apiName, path, myInit)

  return (res.data)
}

const addToShelfEdgeLabels = async (siteId, data) => {
  // Rest Api call
  const apiName = 'Common API'
  const path = `/site/${siteId}/shelf_edge_labels`
  const myInit = { // OPTIONAL
    headers: {}, // OPTIONAL
    response: true,
    body: {
      selList: data
    } // OPTIONAL (return the entire Axios response object instead of only response.data)
  }
  const res = await API.put(apiName, path, myInit)

  return (res.data)
}

const getPortalUsers = async () => {
  // Rest Api call
  const apiName = 'Common API'
  const path = '/portal/user_management'
  const myInit = {
    headers: {},
    response: true
  }

  try {
    // await API.get(apiName, path, myInit)
    const res = await API.get(apiName, path, myInit)

    return (res)
  } catch (err) {
    return (err)
  }
}

const updatePortalUser = async (siteId, data) => {
  // Rest Api call
  const apiName = 'Common API'
  const path = '/portal/user_management'
  const myInit = { // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      userId: data.userId,
      username: data.username,
      email: data.email
    }
  }

  try {
    const res = await API.post(apiName, path, myInit)

    return (res.data)
  } catch (err) {
    return (err.response.data)
  }
}

const deletePortalUser = async (data) => {
  // Rest Api call
  const apiName = 'Common API'
  const path = '/portal/user_management'
  const myInit = { // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      users: data
    }
  }
  const res = await API.del(apiName, path, myInit)

  return (res.data)
}

const getPosUsers = async (siteId, data) => {
  // Rest Api call
  const apiName = 'Common API'
  const path = `/site/${siteId}/user_management`
  const myInit = { // OPTIONAL
    headers: {}, // OPTIONAL
    response: true // OPTIONAL (return the entire Axios response object instead of only response.data)
  }
  const res = await API.get(apiName, path, myInit)

  return (res.data)
}

const updatePosUser = async (siteId, data) => {
  // Rest Api call
  const apiName = 'Common API'
  const path = `/site/${siteId}/user_management`
  const myInit = { // OPTIONAL
    headers: {}, // OPTIONAL
    response: true,
    body: {
      userId: data.userId || null,
      username: data.username,
      role: data.role,
      pin: data.pin
    } // OPTIONAL (return the entire Axios response object instead of only response.data)
  }
  try {
    const res = await API.post(apiName, path, myInit)

    return (res.data)
  } catch (err) {
    return (err.response.data)
  }
}

const deletePosUser = async (siteId, data) => {
  // Rest Api call
  const apiName = 'Common API'
  const path = `/site/${siteId}/user_management`
  const myInit = { // OPTIONAL
    headers: {}, // OPTIONAL
    response: true,
    body: {
      users: data
    } // OPTIONAL (return the entire Axios response object instead of only response.data)
  }
  const res = await API.del(apiName, path, myInit)

  return (res.data)
}

const publishPosUsers = async (siteId) => {
  // Rest Api call
  const apiName = 'Common API'
  const path = `/site/${siteId}/user_management/publish`
  const myInit = {
    headers: {},
    response: true,
    body: {}
  }

  try {
    const response = await API.post(apiName, path, myInit)

    if (response.data.status === 200) {
      return (response.data)
    }
  } catch (err) {
    console.log(err)

    return (err.response.data)
  }
}

export {
  dashboardResponse,
  reportResponse,
  registerSitesResponse,
  maskOrgResponse,
  getProducts,
  siteSummary,
  getCategories,
  getSpecificCategories,
  addCategory,
  deleteCategory,
  getSiteProducts,
  getSiteProductLookups,
  saveProductOverrides,
  getHotkeyElements,
  saveHotkeyElements,
  getHotkeyLookups,
  productSearch,
  publishHotkeys,
  getHotkeysPublishStatus,
  getShelfEdgeLabels,
  addToShelfEdgeLabels,
  getPortalUsers,
  updatePortalUser,
  deletePortalUser,
  getPosUsers,
  updatePosUser,
  deletePosUser,
  publishPosUsers
}
